import React from "react";
import { Link } from "react-router-dom"
import styles from "./ProtectedLayout.module.scss";
import Navbar from "./Navbar";


import { Layout } from 'antd';
import { confirmAlert } from 'react-confirm-alert';

/**Import Assets */
import logo from "./images/logo.png";
import { useDispatch, useSelector } from "react-redux";
import { updateKey } from "../../features/DefaultReducer";
import link1 from "./images/1.svg";
import link2 from "./images/2.svg";
import link3 from "./images/3.svg";
import link4 from "./images/4.svg";
import link5 from "./images/5.svg";
import link6 from "./images/6.svg";
import link7 from "./images/7.svg";
import link8 from "./images/8.svg";
import link9 from "./images/9.svg";
import link10 from "./images/10.svg";
import post from "./images/post.svg";
import donate from "./images/donate.svg";
import notification from "./images/noti.svg";
import edit from "./images/edit.svg";
import report_post from "./images/report_post.svg";



import { resetState as profileReset } from "../../features/ProfileReducer";
import { resetState as reportReset } from "../../features/ReportManagementReducer";
import { resetState as soundTracksReset } from "../../features/SoundTracksReducer";
import { resetState as textReset } from "../../features/StaticTextReducer";
import { resetState as subscriptionReset } from "../../features/SubscriptionReducer";
import { resetState as userReset } from "../../features/UserManagementReducer";
import { resetState as cashOutReset } from "../../features/CashOutReducer";
import { resetState as constantReset } from "../../features/ConstantReducer";
import { resetState as dashboardReset } from "../../features/DashboardReducer";
import { resetState as postReset } from "../../features/PostManagementReducer";
import { resetValue as searchReset } from "../../features/SearchReducer";



const { Sider } = Layout;

export default function ProtectedLayout({ selectedRoute, isSearchBar, children }) {

    const dispatch = useDispatch();
    const { linkDisabled } = useSelector(state => state.default)
    const items = [
        {
            icon: link1,
            label: "Dashboard",
        },
        {
            icon: link2,
            label: "User Managment",
        },
        {
            icon: link3,
            label: "Sound Tracks",
        },
        {
            icon: link3,
            label: "Upload Sound Tracks",
        },
        {
            icon: link4,
            label: "Cash Out Requests",
        },
        {
            icon: link5,
            label: "Report Management",
        },
        {
            icon: post,
            label: "Post Management",
        },
        {
            icon: report_post,
            label: "Post Reports",
        },
        {
            icon: link6,
            label: "Subscription",
        },
        {
            icon: donate,
            label: "Donate History",
        }, {
            icon: link7,
            label: "Terms And Conditions",
        },
        {
            icon: link8,
            label: "Privacy Policy",
        },
        {
            icon: link9,
            label: "FAQs",
        },
        {
            icon: edit,
            label: "Constants",
        },
        {
            icon: notification,
            label: "Notifications",
        },
        {
            icon: edit,
            label: "Change Password",
        },

    ]

    function handleLogout() {
        dispatch(updateKey({ isLoggedIn: false }));
        dispatch(profileReset());
        dispatch(reportReset());
        dispatch(soundTracksReset())
        dispatch(textReset())
        dispatch(subscriptionReset())
        dispatch(userReset())
        dispatch(cashOutReset())
        dispatch(constantReset())
        dispatch(dashboardReset())
        dispatch(postReset())
        dispatch(searchReset())
        localStorage.removeItem("web_token")

    }

    function submit(title, message, cb, rejectCB = () => { }) {
        confirmAlert({
            title,
            message,
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => cb()
                },
                {
                    label: 'No',
                    onClick: () => rejectCB()
                }
            ],
            closeOnEscape: true,
            closeOnClickOutside: true,
            keyCodeForClose: [8, 32],
        });
    }



    return (
        <div className={styles.protectedLayout}>
            <Sider trigger={null} style={{ height: "100vh" }} className={styles.sider} width={270} >
                <div className={styles.children}>

                    <Link className={styles.logo} to={`/dashboard`}>
                        <img src={logo} alt="Logo Image" />

                    </Link>
                    <div className={styles.menu}>
                        {items.map(({ icon, label }, index) => {
                            return <Link
                                to={`/${label.toLowerCase().replace(/[^A-Z0-9]/ig, "-")}`}
                                className={`${styles.item} ${index == selectedRoute ? styles.active : ""}`}
                                key={index}
                                onClick={e => linkDisabled && e.preventDefault()}
                            >
                                <img src={icon} alt={`Icon${index}`} width={20} height={20} />
                                <p>{label}</p>
                            </Link>
                        })}
                        <Link
                            className={styles.item}
                            onClick={(e) => linkDisabled ? e.preventDefault() : submit("Confirm Logout", "Are you sure you want to logout?", () => handleLogout())} >
                            <img src={link10} alt="Icon1" width={20} height={20} />
                            <p>Logout</p>
                        </Link>

                    </div>

                </div>


            </Sider >
            <div className={styles.routeContent}>
                <Navbar isSearchBar={isSearchBar} />
                <div className={styles.content}>
                    {children}
                </div>
            </div>
        </div >
    )
}